module.exports = __webpack_public_path__ + "img/coingecko.82a4a88a.png";